// imports
import Link from 'next/link';
import { useAtom } from 'jotai';

// lib files
import { searchFiltersAtom } from '@/lib/atoms/search-filters';
import { ShowRowContent, ShowOrFranchiseEnum } from '@/lib/types/api/show-data';
import { Franchise } from '@/lib/types/api/franchise-data';

// components
import ShowRow from '@/components/ShowRow/ShowRow';

// styles
import styles from './SearchShowResults.module.scss';

interface SearchShowResultsProps {
  searchShowResults: {
    content: Array<ShowRowContent | Franchise>;
  };
}

const SearchShowResults = (props: SearchShowResultsProps) => {
  const { searchShowResults } = props;
  const [searchFilters] = useAtom(searchFiltersAtom);

  // falling back to an empty string mostly for storybook
  const query = searchFilters.query || '';

  const { content: shows } = searchShowResults;

  const franchises = shows.filter((show: ShowRowContent | Franchise) => show.item_type === ShowOrFranchiseEnum.Franchise);
  const plainShows = shows.filter((show: ShowRowContent | Franchise) => show.item_type === ShowOrFranchiseEnum.Show);

  // move franchises to the front of the list
  const showsToDisplay = [...franchises, ...plainShows];
  const titleText = shows.length > 1 ? "Shows" : "Show";

  const overRideOptions = {
    perPage: 3,
    gap: '8px',
    breakpoints: {
      600: {
        perPage: 4,
      },
      1024: {
        gap: '12px',
        perPage: 5,
      },
      1440: {
        gap: '16px',
        perPage: 6,
      },
    },
  };

  if (showsToDisplay.length === 0) {
    return null;
  }

  return (
    <div className={styles.search_show_results}>
      <h2 className={styles.search_show_results_title}>
        <Link href={`/shows?search=${query}`}>
          {titleText}
        </Link>
      </h2>

      <ShowRow
        shows={showsToDisplay}
        className={styles.search_results_show_row}
        overRideOptions={overRideOptions}
      />
    </div>
  );
};

export default SearchShowResults;
